<template>
  <div>
    <vx-card title="Social Links" class="mt-3" style="min-height:250px;">
        <div
            class="flex"
            vs-align="flex-end"
            style="float:right;margin-top: -5.2%;"
          >
          <vs-button
            type="border"
            color="primary"
            style="font-size: 13.8px; padding: 7px; float: right; margin-top: -3.2%;"
            @click="handleEditSocial"
          >
            Edit
          </vs-button>
      <!-- </vs-button>
            <vs-button
              color="primary"
              class="mr-2"
              vs-type="flex"

            >Edit</vs-button> -->
          </div>
        <div class="vx-row">
          <vs-row class="p-5">
            <vs-row>
              <vs-col :vs-xs="3" :vs-md="3" :vs-lg="3">
                <vs-icon icon-pack="feather" icon="icon-facebook" class="socialIcon"/>
              </vs-col>
              <vs-col :vs-xs="9" :vs-md="9" :vs-lg="9">
                {{localvalue.facebook}}
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col :vs-xs="3" :vs-md="3" :vs-lg="3">
                <vs-icon icon-pack="feather" icon="icon-instagram" class="socialIcon"/>
              </vs-col>
              <vs-col :vs-xs="9" :vs-md="9" :vs-lg="9">
                {{localvalue.instagram}}
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col :vs-xs="3" :vs-md="3" :vs-lg="3">
                <vs-icon icon-pack="feather" icon="icon-twitter" class="socialIcon"/>
              </vs-col>
              <vs-col :vs-xs="9" :vs-md="9" :vs-lg="9">
                {{localvalue.twitter}}
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col :vs-xs="3" :vs-md="3" :vs-lg="3">
                <vs-icon icon-pack="feather" icon="icon-linkedin" class="socialIcon"/>
              </vs-col>
              <vs-col :vs-xs="9" :vs-md="9" :vs-lg="9">
                {{localvalue.linkedin}}
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col :vs-xs="3" :vs-md="3" :vs-lg="3">
                <vs-icon icon-pack="feather" icon="icon-quara" class="socialIcon"/>
              </vs-col>
              <vs-col :vs-xs="9" :vs-md="9" :vs-lg="9">
                {{localvalue.quara}}
              </vs-col>
            </vs-row>
          </vs-row>
        </div>
      </vx-card>
      <vs-popup classContent="popup-example"  title="Edit " :active.sync="editSocial">
      <form data-vv-scope="add">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input v-validate="'required'" name="facebook" v-model="editSocialData.facebook" class="custom_Input" label="Facebook" icon-pack="feather" icon="icon-facebook" icon-before placeholder="facebook" style="width:100%;" vs-placeholder="facebook" />
              <span v-show="errors.has('add.facebook')" class="text-danger">{{ errors.first('add.facebook') }}</span>
            </vs-col>
            <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input v-validate="'required'" v-model="editSocialData.instagram" name="instagram" class="custom_Input" label="Instagram" icon-pack="feather" icon="icon-instagram" icon-before placeholder="instagram" style="width:100%;" vs-placeholder="instagram"/>
              <span v-show="errors.has('add.instagram')" class="text-danger">{{ errors.first('add.instagram') }}</span>
            </vs-col>
            <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input v-validate="'required'" name="twitter" v-model="editSocialData.twitter" label="Twitter" icon-pack="feather" icon="icon-twitter" icon-before placeholder="twitter" style="width:100%;" vs-placeholder="twitter"/>
              <span v-show="errors.has('add.twitter')" class="text-danger">{{ errors.first('add.twitter') }}</span>
            </vs-col>
            <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input v-validate="'required'" name="linkedin" v-model="editSocialData.linkedin" class="custom_Input" label="Linkedin" icon-pack="feather" icon="icon-linkedin" icon-before placeholder="linkedin" style="width:100%;" vs-placeholder="linkedin"/>
              <span v-show="errors.has('add.linkedin')" class="text-danger">{{ errors.first('add.linkedin') }}</span>
            </vs-col>
            <vs-col :vs-xs="6" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input v-validate="'required'" name="quara" v-model="editSocialData.quara" class="custom_Input" label="Quara" icon-pack="feather" icon="icon-quara" icon-before placeholder="quara" style="width:100%;" vs-placeholder="quara"/>
              <span v-show="errors.has('add.quara')" class="text-danger">{{ errors.first('add.quara') }}</span>
            </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleSavesocial">Save</vs-button>
        <vs-button type="border" color="danger" @click="handleAddCancel">Cancel</vs-button>
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
export default {
  name: 'ClientSocialLink',
  props: {
    value: {
      required: true,
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      editSocialData : {
        facebook:null,
        instagram: null,
        twitter:null,
        linkedin: null,
        quara: null
      },
      editSocial:false
    }
  },
  computed: {
    localvalue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleSavesocial () {
      this.$validator.validateAll('add').then(result => {
        if (result) {
          this.localvalue.facebook  = this.editSocialData.facebook
          this.localvalue.instagram  = this.editSocialData.instagram
          this.localvalue.twitter  = this.editSocialData.twitter
          this.localvalue.linkedin  = this.editSocialData.linkedin
          this.localvalue.quara  = this.editSocialData.quara
          this.handleAddCancel()
          this.$validator.reset()
        }
      })
    },
    handleAddCancel () {
      this.editSocial = false
      this.editSocialData = {
        facebook:null,
        instagram: null,
        twitter:null,
        linkedin: null,
        quara: null
      }
      this.$validator.reset()
    },
    handleEditSocial () {
      this.editSocialData.facebook = this.localvalue.facebook
      this.editSocialData.instagram = this.localvalue.instagram
      this.editSocialData.twitter = this.localvalue.twitter
      this.editSocialData.linkedin = this.localvalue.linkedin
      this.editSocialData.quara = this.localvalue.quara
      this.editSocial = true
    }
  }
}
</script>
<style scoped>
.socialIcon{
  font-size:30px;
}
</style>
